var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_credit_card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.5 32.5V12.5C42.5 11.1739 41.9732 9.90215 41.0355 8.96447C40.0979 8.02678 38.8261 7.5 37.5 7.5H32.5M32.5 7.5H17.5C16.1739 7.5 14.9021 8.02678 13.9645 8.96447C13.0268 9.90215 12.5 11.1739 12.5 12.5V42.5C12.5 43.8261 13.0268 45.0979 13.9645 46.0355C14.9021 46.9732 16.1739 47.5 17.5 47.5H35M32.5 7.5V33.75M22.5 17.5V25",
    stroke: "#E51428",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.5002 55V37.25C52.4997 34.9515 52.0464 32.6755 51.1662 30.5522C50.286 28.4289 48.9961 26.4997 47.3702 24.875L42.4952 20V36.4675C42.4952 38.6925 39.8027 39.81 38.2277 38.235L34.9902 35C33.7402 33.75 30.7377 33 28.7352 35C26.7352 37 27.4852 40 28.7352 41.25L42.4927 55",
    stroke: "#E51428",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.0e45c6fa92432338b96f1fe7daef00fc.svg";
export { ForwardRef as ReactComponent };